class Usuario {
  constructor(id, name, username, email, agent) {
    this.id = id
    this.name = name
    this.username = username
    this.email = email
    this.agent = agent
    this.roles = []
    this.skin = []
  }
  getId() {
    return this.id
  }

  setId(id) {
    this.id = id
  }

  getName() {
    return this.name
  }

  setName(name) {
    this.name = name
  }

  getUsername() {
    return this.username
  }

  setUsername(username) {
    this.username = username
  }

  getEmail() {
    return this.email
  }

  setEmail(email) {
    this.email = email
  }

  getAgent() {
    return this.agent
  }

  setAgent(agent) {
    this.agent = agent
  }
}
export {
    Usuario as default
}



// WEBPACK FOOTER //
// ./src/model/Usuario.js